import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnterpriseFeatureService {

  constructor() { }

  getAllSubscriptions(): void {
    console.log('getAllSubscriptions called');
  }
}
